/**
 * Copyright (c) 2022 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */

import { useEffect, useRef } from 'react';

export function useInterval(callback: () => void, delay: number, dependencies: any[] = []) {
  const savedCallback = useRef(callback);

  // Remember the latest callback.
  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  // Set up the interval.
  useEffect(() => {
    const tick = () => savedCallback.current();
    tick();
    const id = setInterval(tick, delay);
    return () => clearInterval(id);
  }, dependencies);
}
